import $ from 'jquery';
import './modules/searchplus';

const opts = window.searchPlusOpts || {};
$(this).searchplus(opts);
